












































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SensorUsageRecommendationComponent extends Vue {
  @Prop()
  replaceCloseWithAbort!: boolean;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  show() {
    this.baseDialogComponent.show({
      title: this.$t("comBoxDetail.sensorUsageRecommendation.title").toString(),
      positiveButtonText: this.$t("common.ok").toString(),
      negativeButtonText: this.replaceCloseWithAbort
        ? this.$t("common.abort").toString()
        : undefined,
      closeOnSave: true,
      persistent: false,
    });

    this.baseDialogComponent.isShowing = true;

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onAccept() {
    this.baseDialogComponent.isShowing = false;
    this.resolve && this.resolve(true);
  }

  onReject() {
    this.baseDialogComponent.isShowing = false;
    this.resolve && this.resolve(false);
  }
}
